import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/state/appState';
import { AppDispatch } from '../../store/actions/appDispatch';
import { loadEngagementIfMissing } from '../../store/actions/engagementsActions';
import PageLoadingSpinner from '../PageLoadingSpinner';
import api from '../../helpers/api';
import Spinner from '../Spinner';
import { useHistory } from 'react-router';
import { clearCreateJob } from '../../store/actions/createJobActions';
import { JobListQuery, JobSummary } from '../../models/dto/job';
import {PagedResult} from "../../models/dto/pagedResult";
import { EngagementExpandedSummary, EngagementSummary } from '../../models/dto/engagement';

export default function EngagementDetailsPage() {
	const rawEngagementId = useParams<any>().engagementId;
	const engagementId = parseInt(rawEngagementId);
	const engagement = useSelector<AppState, EngagementExpandedSummary | undefined>(s => s.engagements.details.get(engagementId));
	const [jobsData, setJobsData] = useState<JobsData>({ engagementId, jobs: null });
	const dispatch = useDispatch<AppDispatch>();
	const history = useHistory();
	
	useEffect(() => {
		dispatch(loadEngagementIfMissing(engagementId));
		
		setJobsData({engagementId, jobs: null});
		
		const query: JobListQuery = { engagementId, pageSize: 10000, pageIndex: 1 };
		api.get<PagedResult<JobSummary>>('/api/jobs', { params: query }).then(response => {
			setJobsData(prev => {
				// check to make sure that we are still the relevant
				// jobs request
				return prev.engagementId === engagementId
					? { engagementId, jobs: response.data.items ?? [] }
					: prev;
			});
		});
	}, [engagementId]);
	
	if (!engagement)
		return <PageLoadingSpinner />
	
	return (
		<React.Fragment>
			<div className="page-container page-container_more-space-on-top">
				<h1 className="text-center h1-mb-1">{engagement.account?.name}</h1>

				<div className="header-description-container">
					Start a new job to begin uploading calls
				</div>

				<div className="text-center mb-8">
					<button className="btn btn_wide" onClick={handleCreateJob}>Start a new upload job</button>
				</div>
				
				{getJobsSection()}
			</div>
		</React.Fragment>
	);
	
	function getJobsSection() {
		const jobs = jobsData.jobs;
		
		if (!jobs)
			return <Spinner />;

		const completed = jobs.filter(j => j.complete) ?? [],
			inProgress = jobs.filter(j => !j.complete) ?? [];
		
		return (
			<React.Fragment>
				<h3 className="h3-mb-1">Jobs in progess</h3>
				<div className="boxed-list__container mb-6">
					{inProgress.map(j => (
						<div key={j.id} className="boxed-list__item">
							<Link to={getJobLink(j.id)}>{j.name || 'Unknown'}</Link>
						</div>
					))}
					{!inProgress.length &&
					<div className="boxed-list__item boxed-item__item_empty">
						No jobs in progess
					</div>
					}
				</div>

				<h3 className="h3-mb-1">Completed jobs</h3>
				<div className="boxed-list__container mb-6">
					{completed.map(j => (
						<div key={j.id} className="boxed-list__item">
							<Link to={getJobLink(j.id)}>{j.name || 'Unknown'}</Link>
						</div>
					))}
					{!completed.length &&
					<div className="boxed-list__item boxed-item__item_empty">
						No completed jobs
					</div>
					}
				</div>
			</React.Fragment>	
		)
	}

	function getJobLink(jobId: number): string {
		return `/engagements/${engagementId}/jobs/${jobId}`;
	}
	
	function handleCreateJob() {
		dispatch(clearCreateJob(engagementId));
		history.push(`/engagements/${engagementId}/jobs/create`);
	}
}

interface JobsData {
    engagementId: number;
    jobs: JobSummary[] | null;
}


